import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { on as wsOn } from "@/lib/socket";
import { formatIST } from "@/lib/format";

export default function SimulatorTelegram() {
    const [tab, setTab] = useState("team");
    const [rows, setRows] = useState([]);

    const load = () =>
        api.get("/telegram/mock/messages", { params: { chat_type: tab } }).then((r) =>
            setRows(r.data),
        );

    useEffect(() => {
        load();
        const off = wsOn("tg:message", (d) => d.chat_type === tab && load());
        return () => off();
        // eslint-disable-next-line
    }, [tab]);

    return (
        <div className="space-y-4" data-testid="simulator-telegram">
            <div>
                <h1 className="text-2xl font-bold tracking-tight">Telegram simulator</h1>
                <p className="text-xs text-muted-foreground">
                    All system notifications the bot would post in real Telegram.
                </p>
            </div>
            <div className="flex gap-1 border-b border-border">
                {[
                    { k: "team", label: "Team group" },
                    { k: "admin", label: "Admin chat" },
                ].map((t) => (
                    <button
                        key={t.k}
                        data-testid={`telegram-tab-${t.k}`}
                        onClick={() => setTab(t.k)}
                        className={`px-4 py-2 text-xs border-b-2 ${
                            tab === t.k
                                ? "border-primary text-foreground"
                                : "border-transparent text-muted-foreground hover:text-foreground"
                        }`}
                    >
                        {t.label}
                    </button>
                ))}
            </div>
            <div className="bg-card border border-border rounded-md divide-y divide-border">
                {rows.length === 0 && (
                    <div className="text-sm text-muted-foreground p-6 text-center">
                        No messages yet in this channel.
                    </div>
                )}
                {rows.map((m) => (
                    <div key={m.id} className="p-3 text-sm whitespace-pre-wrap font-mono">
                        <div className="text-[10px] text-muted-foreground uppercase tracking-wider mb-1">
                            {formatIST(m.created_at)}
                        </div>
                        {m.body}
                    </div>
                ))}
            </div>
        </div>
    );
}
